/* eslint-disable */
// @ts-nocheck
import { useContext } from 'react';

import GoogleMapContext from './context';

const useGoogleMapContext = () => useContext(GoogleMapContext);

export default useGoogleMapContext;
